import { useContext } from "react";
import { AuthContext } from "../contexts";

export const useAuth = () => useContext(AuthContext); // Exportamos el hook useAuth para que pueda ser utilizado en cualquier componente
